<template>
  <Card variant="outline" size="medium">
    <template #header>
      <Text variant="h4">Employment</Text>
      <slot name="actions" />
    </template>

    <div class="details" v-if="employmentInfo.length">
      <EmploymentInfoItem v-for="info in employmentInfo" :key="info.id" :employment="info" />
    </div>

    <Text v-else variant="body-medium">No info</Text>
  </Card>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { Card, Text } from '@tallo/design-system';

import { ApplicationEmploymentInfoDto, ApplicationEmploymentInfoType } from '../../interfaces/employment.interface';
import EmploymentInfoItem from './employment-item.vue';

const props = defineProps<{ employmentInfo: ApplicationEmploymentInfoDto[] }>();

const employmentInfo = computed(() =>
  [...props.employmentInfo].sort((a) => (a.type === ApplicationEmploymentInfoType.CURRENT ? -1 : 1)),
);
</script>

<style scoped lang="scss">
@import 'styles/mixins/layout.mixins';

.details {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--t-spacing-md);

  @include mobile {
    grid-template-columns: 1fr;
  }
}
</style>
